import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, Users } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Badge } from "./ui/badge";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-slate-950 text-white border-b border-slate-800">
      <div className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => navigate("/dashboard")}
          className="flex items-center gap-3 group"
        >
          <div className="h-9 w-9 rounded-lg overflow-hidden ring-1 ring-amber-500/40 group-hover:ring-amber-400 transition">
            <img src="/logo.png" alt="Logo" className="h-full w-full object-cover" />
          </div>
          <span className="font-display text-lg font-extrabold tracking-tight" data-testid="navbar-brand-title">Silvestre&amp;Maia - IA</span>
        </button>

        {user && (
          <div className="flex items-center gap-2">
            {user.role === "admin" && (
              <button data-testid="nav-admin-btn" onClick={() => navigate("/admin")}
                className="hidden sm:flex items-center gap-2 text-sm text-slate-300 hover:text-white px-3 py-2 rounded-lg hover:bg-slate-800 transition">
                <Users className="h-4 w-4" /> Usuários
              </button>
            )}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button data-testid="user-menu-trigger" className="flex items-center gap-3 hover:opacity-90">
                <div className="text-right hidden sm:block">
                  <div className="text-sm font-semibold leading-tight">{user.name || user.email}</div>
                  <div className="text-[11px] text-slate-400 capitalize">{user.role}</div>
                </div>
                <Avatar className="h-9 w-9 border border-slate-700">
                  <AvatarImage src={user.picture} />
                  <AvatarFallback className="bg-amber-600 text-white text-sm">
                    {(user.name || user.email || "U").charAt(0).toUpperCase()}
                  </AvatarFallback>
                </Avatar>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <DropdownMenuLabel>
                <div className="flex flex-col">
                  <span className="font-semibold">{user.name}</span>
                  <span className="text-xs text-muted-foreground font-normal">{user.email}</span>
                  <Badge variant="secondary" className="mt-2 w-fit capitalize">{user.role}</Badge>
                </div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem data-testid="logout-btn" onClick={logout} className="text-rose-600">
                <LogOut className="h-4 w-4 mr-2" /> Sair
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          </div>
        )}
      </div>
    </header>
  );
}
